module.exports = __webpack_public_path__ + "static/media/moons_comer_brackets-1800.5f928b89.webp";